module.exports = __webpack_public_path__ + "static/media/extinguishers.ac561495.png";